/** Constraint count that triggers non-blocking employee guidance. */
export const EMPLOYEE_CONSTRAINT_WARNING_COUNT = 20;

/** Total constraint characters that trigger non-blocking employee guidance. */
export const EMPLOYEE_CONSTRAINT_WARNING_CHARACTERS = 8_000;
